{
  "el": {
    "chart": {
      "type": {
        "bar": "Ραβδόγραμμα",
        "bubble": "Διάγραμμα φυσαλίδων",
        "doughnut": "Δακτυλιοειδές διάγραμμα",
        "horizontalBar": "Οριζόντιο ραβδόγραμμα",
        "line": "Γραμμικό διάγραμμα",
        "multiAxis": "Διάγραμμα πολλαπλών αξόνων",
        "pie": "Κυκλικό διάγραμμα",
        "polarArea": "Διάγραμμα πολικών περιοχών",
        "radar": "Διάγραμμα ραντάρ",
        "stackedBar": "Στοιβαγμένο ραβδόγραμμα"
      }
    }
  }
}
